import React, { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { useLocation } from "react-router-dom";
import { getConsent, saveConsent, loadTrackers, trackersConfigured, captureAttribution } from "@/lib/tracking";

export const openCookieSettings = () => window.dispatchEvent(new Event("open-cookie-settings"));

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [custom, setCustom] = useState(false);
  const [ads, setAds] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    captureAttribution();
    if (!trackersConfigured()) return;
    const c = getConsent();
    if (c) { setAds(c.ads); loadTrackers(); } else setOpen(true);
    const reopen = () => { setAds(getConsent()?.ads || false); setCustom(true); setOpen(true); };
    window.addEventListener("open-cookie-settings", reopen);
    return () => window.removeEventListener("open-cookie-settings", reopen);
  }, []);

  if (!open || pathname.startsWith("/admin")) return null;
  const decide = (v) => { saveConsent(v); setOpen(false); };
  const btn = "px-5 py-2.5 rounded-full text-sm font-semibold transition-colors";

  return (
    <div data-testid="cookie-banner" role="dialog" aria-label="Gestion des cookies" className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60] bg-white border border-md-border rounded-3xl shadow-2xl p-6 animate-fade-up">
      <div className="flex items-center gap-2 mb-3">
        <Cookie className="w-5 h-5 text-md-secondary" />
        <div className="font-serif text-xl text-md-primary">Vos choix de cookies</div>
      </div>
      <p className="text-sm text-md-muted leading-relaxed mb-4">
        Avec votre accord, j'utilise des cookies de Google Ads et Meta pour mesurer l'efficacité de mes publicités et vous
        proposer des annonces pertinentes. Vous pouvez refuser sans conséquence sur votre navigation. Votre choix est conservé
        6 mois et modifiable à tout moment via « Gérer les cookies ». <a href="/confidentialite" className="underline text-md-primary">En savoir plus</a>
      </p>
      {custom && (
        <label className="flex items-start gap-3 text-sm text-md-text bg-md-bg rounded-2xl p-4 mb-4 cursor-pointer">
          <input type="checkbox" data-testid="cookie-ads-toggle" checked={ads} onChange={(e) => setAds(e.target.checked)} className="mt-0.5 w-4 h-4 accent-md-secondary" />
          <span><strong className="text-md-primary">Publicité et mesure (Google Ads, Meta)</strong> — mesure des demandes issues des publicités et reciblage.</span>
        </label>
      )}
      <div className="flex flex-wrap gap-2">
        <button data-testid="cookie-refuse" onClick={() => decide(false)} className={`${btn} bg-md-primary text-white hover:bg-md-primaryHover`}>Tout refuser</button>
        <button data-testid="cookie-accept" onClick={() => decide(true)} className={`${btn} bg-md-primary text-white hover:bg-md-primaryHover`}>Tout accepter</button>
        {custom ? (
          <button data-testid="cookie-save" onClick={() => decide(ads)} className={`${btn} border border-md-border text-md-primary hover:border-md-primary`}>Enregistrer mes choix</button>
        ) : (
          <button data-testid="cookie-customize" onClick={() => setCustom(true)} className={`${btn} border border-md-border text-md-primary hover:border-md-primary`}>Personnaliser</button>
        )}
      </div>
    </div>
  );
}
